import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { StoreLocatorCard, StoreLocatorContext, StoreLocatorMap, useStoreLocator, } from "../../../../components/StoreLocator";
import { StoreLocatorProviderWrapper } from "../../../../components/StoreLocator/components/StoreLocatorProviderWrapper";
import styles from "../../StoreDetails.module.scss";
export const StoreDetailsMap = (props) => {
    const { store } = props;
    const storeLocatorData = useStoreLocator({
        defaultLat: String(store.Location.lat || 0),
        defaultLng: String(store.Location.lon || 0),
        defaultZoom: 15,
        activeStore: store,
        ...props,
    });
    return (_jsx(StoreLocatorProviderWrapper, { children: _jsxs(StoreLocatorContext.Provider, { value: storeLocatorData, children: [_jsx(StoreLocatorCard, { className: styles.storeDetailsCard, isActive: false, store: store, isListView: false }), _jsx("div", { className: styles.mapContainer, children: _jsx(StoreLocatorMap, {}) })] }) }));
};
//# sourceMappingURL=StoreDetailsMap.js.map